module.exports = __webpack_public_path__ + "static/media/sideButton.f2bff8e2.svg";